var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar7333844(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-7333844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 5.25H18.75V4C18.75 3.59 18.41 3.25 18 3.25C17.59 3.25 17.25 3.59 17.25 4V5.25H12.75V4C12.75 3.59 12.41 3.25 12 3.25C11.59 3.25 11.25 3.59 11.25 4V5.25H6.75V4C6.75 3.59 6.41 3.25 6 3.25C5.59 3.25 5.25 3.59 5.25 4V5.25H5C3.48 5.25 2.25 6.48 2.25 8V18C2.25 19.52 3.48 20.75 5 20.75H19C20.52 20.75 21.75 19.52 21.75 18V8C21.75 6.48 20.52 5.25 19 5.25ZM20.25 18C20.25 18.69 19.69 19.25 19 19.25H5C4.31 19.25 3.75 18.69 3.75 18V8C3.75 7.31 4.31 6.75 5 6.75H19C19.69 6.75 20.25 7.31 20.25 8V18Z",
    fill: "#2A364E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 10.25H7C6.59 10.25 6.25 10.59 6.25 11C6.25 11.41 6.59 11.75 7 11.75H17C17.41 11.75 17.75 11.41 17.75 11C17.75 10.59 17.41 10.25 17 10.25ZM13 14.25H7C6.59 14.25 6.25 14.59 6.25 15C6.25 15.41 6.59 15.75 7 15.75H13C13.41 15.75 13.75 15.41 13.75 15C13.75 14.59 13.41 14.25 13 14.25Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar7333844);
export default __webpack_public_path__ + "static/media/calendar-7333844.5fec9fe65e64a2045c023ffd4d6bfb3f.svg";
export { ForwardRef as ReactComponent };